import { useEffect, useState, useCallback } from "react";
import api from "../api";

const MODES = {
  zoom: "Videoriunione Zoom", phone: "Telefonata", presenza: "Riunione in studio",
  trasferta: "Trasferta dal cliente", scelta: "Da concordare",
};
const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

function useQuery() {
  const p = new URLSearchParams(window.location.search);
  return { mode: p.get("mode") || p.get("modalita") || "scelta", nome: p.get("nome") || "", email: p.get("email") || "", tel: p.get("tel") || "", src: p.get("src") || "" };
}

export default function PublicBooking() {
  const q = useQuery();
  const [cfg, setCfg] = useState(null);
  const [date, setDate] = useState("");
  const [slots, setSlots] = useState([]);
  const [dayInfo, setDayInfo] = useState({});
  const [slotInfo, setSlotInfo] = useState(null);
  const [time, setTime] = useState("");
  const [mode, setMode] = useState(q.mode);
  const [form, setForm] = useState({ name: q.nome, email: q.email, phone: q.tel });
  const [privacy, setPrivacy] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);

  useEffect(() => { api.get("/booking-config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const start = new Date(); start.setHours(0, 0, 0, 0);
    const s = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, "0")}-${String(start.getDate()).padStart(2, "0")}`;
    api.get(`/appointments/bookable-days?start=${s}&days=28`).then((r) => {
      const m = {}; r.data.forEach((d) => { m[d.date] = d; }); setDayInfo(m);
    }).catch(() => {});
  }, []);

  const loadSlots = useCallback((d) => {
    if (!d) return;
    setLoadingSlots(true);
    api.get(`/appointments/slots?date=${d}`)
      .then((r) => { setSlots(r.data.slots || []); setSlotInfo(r.data); setTime(""); })
      .catch(() => { setSlots([]); setSlotInfo(null); })
      .finally(() => setLoadingSlots(false));
  }, []);
  useEffect(() => { loadSlots(date); }, [date, loadSlots]);

  // prossimi 21 giorni
  const days = [];
  const base = new Date(); base.setHours(0, 0, 0, 0);
  for (let i = 0; i < 28; i++) { const d = new Date(base); d.setDate(base.getDate() + i); days.push(d); }
  const dkey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

  const submit = async () => {
    if (!date || !time) { alert("Seleziona giorno e orario"); return; }
    if (!form.name) { alert("Inserisci il tuo nome"); return; }
    if (!form.email && !form.phone) { alert("Inserisci email o telefono"); return; }
    if (!privacy) { alert("È necessario accettare l'informativa privacy"); return; }
    setBusy(true);
    try {
      await api.post("/appointments/book", {
        date, time, dur: cfg?.slot_minutes || 30, mode,
        name: form.name, email: form.email || null, phone: form.phone || null, privacy: true,
        marketing,
        source: q.src || null,
        utm_source: q.utm_source || null, utm_medium: q.utm_medium || null,
        utm_campaign: q.utm_campaign || null, utm_content: q.utm_content || null,
        gclid: q.gclid || q.gbraid || q.wbraid || null,
        referrer: document.referrer || null,
        landing_page: window.location.href.slice(0, 400),
      });
      setDone(true);
    } catch (e) { alert(e.response?.data?.detail || "Errore nella prenotazione"); } finally { setBusy(false); }
  };

  if (!cfg) return <div className="public-wrap"><p className="muted">Caricamento…</p></div>;

  if (done) return (
    <div className="public-wrap" data-testid="booking-success">
      <div className="public-card" style={{ textAlign: "center" }}>
        <h1 style={{ color: "#22c55e" }}>Richiesta inviata!</h1>
        <p>Grazie {form.name?.split(" ")[0]}. SC Dottori Commercialisti Srl Stp (Dott.ssa Silvia Casali) confermerà al più presto l'appuntamento del <strong>{date.split("-").reverse().join("/")}</strong> alle <strong>{time}</strong>.</p>
        <p className="muted">Riceverai conferma via {form.email ? "email" : "WhatsApp/telefono"}.</p>
      </div>
    </div>
  );

  const modesEnabled = cfg.modes_enabled || ["zoom", "phone", "presenza"];

  const isFunnel = q.src === "funnel-numeri";

  return (
    <div className="public-wrap">
      <div className="public-card">
        <h1 className="page-title">{isFunnel ? "La tua mezz'ora gratuita" : "Prenota un appuntamento"}</h1>
        <p className="page-sub">{isFunnel ? "30 minuti per guardare i tuoi numeri reali — Studio Dott.ssa Silvia Casali" : "Studio Dott.ssa Silvia Casali — Commercialista"}</p>

        <h3>1. Scegli il giorno</h3>
        <div className="booking-days" data-testid="booking-days">
          {days.map((d) => {
            const k = dkey(d);
            const wd = (d.getDay() + 6) % 7;
            const info = dayInfo[k];
            const disabled = info ? !info.bookable : (wd >= 5 && !(cfg.hours?.[["lun","mar","mer","gio","ven","sab","dom"][wd]]?.length));
            const avail = !disabled && info && info.free_slots > 0;
            return (
              <button key={k} className={"day-chip" + (date === k ? " sel" : "") + (avail ? " avail" : "")} onClick={() => setDate(k)} data-testid={`day-${k}`} disabled={disabled}
                title={disabled ? (info?.reason || (info && info.free_slots === 0 ? "Tutto occupato" : "Non prenotabile")) : `${info?.free_slots ?? ""} orari liberi`}>
                <span className="dc-dow">{["Lun","Mar","Mer","Gio","Ven","Sab","Dom"][wd]}</span>
                <span className="dc-num">{d.getDate()}</span>
                <span className="dc-mon">{MESI[d.getMonth()]}</span>
              </button>
            );
          })}
        </div>

        {date && (
          <>
            <h3>2. Scegli l'orario</h3>
            {loadingSlots ? (
              <p className="muted" data-testid="slots-loading">Controllo l'agenda…</p>
            ) : slotInfo?.blocked ? (
              <p className="muted" data-testid="day-blocked">Lo Studio è chiuso in questa data{slotInfo.reason ? ` (${slotInfo.reason})` : ""}. Scegli un altro giorno.</p>
            ) : slots.length === 0 ? (
              <p className="muted">Nessun orario disponibile in questo giorno.</p>
            ) : (
              <div className="slot-grid" data-testid="slot-grid">
                {slots.map((s) => (
                  <button key={s} className={"slot-chip" + (time === s ? " sel" : "")} onClick={() => setTime(s)} data-testid={`slot-${s}`}>{s}</button>
                ))}
              </div>
            )}
          </>
        )}

        {time && (
          <>
            <h3>3. I tuoi dati</h3>
            {q.mode === "scelta" && (
              <div className="field"><label>Modalità dell'incontro</label>
                <select value={mode} onChange={(e) => setMode(e.target.value)} data-testid="booking-mode">
                  {modesEnabled.map((m) => <option key={m} value={m}>{MODES[m] || m}</option>)}
                </select>
              </div>
            )}
            <div className="field"><label>Nome e cognome *</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="booking-name" /></div>
            <div className="grid-2">
              <div className="field"><label>Email</label><input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="booking-email" /></div>
              <div className="field"><label>Telefono</label><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="booking-phone" /></div>
            </div>
            <label style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 8 }}>
              <input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} data-testid="booking-privacy" style={{ width: "auto", marginTop: 4 }} />
              <span style={{ fontSize: 13 }}>{cfg.privacy_text} <a href="#info" onClick={(e) => { e.preventDefault(); setShowInfo(!showInfo); }}>Leggi l'informativa</a></span>
            </label>
            <label style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 8 }}>
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} data-testid="booking-marketing" style={{ width: "auto", marginTop: 4 }} />
              <span style={{ fontSize: 13 }}>(Facoltativo) Desidero ricevere anche la newsletter e le comunicazioni informative dello Studio su novità fiscali e scadenze. Potrò disiscrivermi in ogni momento con un clic.</span>
            </label>
            {showInfo && <div className="panel" style={{ maxHeight: 220, overflow: "auto", fontSize: 12, whiteSpace: "pre-wrap" }}>{cfg.privacy_informativa}</div>}
            <div style={{ marginTop: 16 }}>
              <button className="btn primary" onClick={submit} disabled={busy} data-testid="booking-submit">{busy ? "Invio…" : "Prenota appuntamento"}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
